import * as yup from 'yup';
import { StringSchema } from 'yup';

/**
 * An email addess schema.
 */
const emailSchema = (required: boolean) => {
  let schema: StringSchema<string> = yup
    .string()
    .label(`Email Address${required ? '' : ' (optional)'}`)
    .email('Must be a valid email address.')
    .ensure() as StringSchema<string>; // conver to empty string if null or undefined
  if (required) {
    schema = yup
      .string()
      .required('Email Address is a required field.')
      .concat(schema);
  } else {
    schema = yup.string().notRequired().concat(schema) as StringSchema<string>;
  }

  return schema;
};

/**
 * Creates a password schema
 */
const passwordSchema = yup
  .string()
  .label('Password')
  .min(8, 'Password must be at least 8 characters.')
  .required()
  .ensure(); // conver to empty string if null or undefined
/**
 * A user name schema.
 */

const userNameSchema = (required: boolean) => {
  let schema: StringSchema<string> = yup
    .string()
    .matches(/^(?=[a-zA-Z0-9._]{3,120}$)(?!.*[_.]{2})[^_.].*[^_.]$/, {
      excludeEmptyString: true,
      message:
        'User names must be at least 3 characters and contain no spaces.',
    })
    .label('User Name')
    .ensure() // conver to empty string if null or undefined
    .trim() as StringSchema<string>;

  if (required) {
    schema = yup
      .string()
      .required('Please provide a user name.')
      .concat(schema);
  } else {
    schema = yup.string().notRequired().concat(schema) as StringSchema<string>;
  }

  return schema;
};

const userNameOrEmailSchema = yup
  .string()
  .matches(/^(?=[a-zA-Z0-9._@]{3,120}$)(?!.*[_.@]{2})[^_.@].*[^_.@]$/, {
    excludeEmptyString: false,
    message: 'Please provide your user name or email address.',
  })
  .label('User Name or Email')
  .required('Please provide a user name or email address.')
  .default('')
  .ensure() // conver to empty string if null or undefined
  .trim();

export { emailSchema, passwordSchema, userNameSchema, userNameOrEmailSchema };
